import React from 'react';
import styled from 'styled-components';
import { Backdrop, TOP_POSITION } from '@comeon/ui';
import breakpoint from '~/utils/style-utils.ts';
import { overlaySmallerTop } from '~/utils/layout-utils.js';

// TODO: Closer look at modal. Also mobile
// Overflow-x: hidden for smaller screens. Just like sidebar-wrapper.js
const Wrapper = styled.div`
	height: ${({ uiContext }) => `calc(100% - ${overlaySmallerTop(uiContext)})`};
	position: fixed;
	top: ${({ uiContext }) => overlaySmallerTop(uiContext)};
	left: 0;
	right: 0;
	bottom: 0;
	-webkit-overflow-scrolling: touch;
	overflow-x: hidden;
	${breakpoint.lg`
		overflow-x: auto;
	`}
	${({ uiContext }) =>
		uiContext.isDesktop &&
		breakpoint.lg` 
		border-radius: 12px;
		box-shadow: 0 24px 24px rgb(0 0 0 / 40%), 0 48px 48px rgb(0 0 0 / 60%);
		top: 10%;
		height: auto;
		position: relative;
		max-height: 80%;
		overflow: hidden;
		`};
`;

const DialogWrapper = React.forwardRef(({ showModal, children, modalUIContext }, ref) => (
	<Backdrop modalPosition={TOP_POSITION} showModal={showModal} transparentModal={modalUIContext?.transparentModal}>
		<Wrapper ref={ref} uiContext={modalUIContext}>
			{children}
		</Wrapper>
	</Backdrop>
));

export default DialogWrapper;
